import { TComponentType } from '@/helpers/editor';
import { Component } from 'vue-property-decorator';
import StudioModalMobile from '@/components/modals/StudioModalMobile.vue';
import EditorBase from '../EditorBase';
import { EModalName } from '@/helpers/modal';
import { Badge } from 'streamlabs-beaker';
import { ISelector } from '@/helpers/utils';

@Component({
  components: {
    StudioModalMobile,
    SBadge: Badge,
  },
})
export default class NewComponentModalMobile extends EditorBase {
  get modalName(): string {
    return EModalName.newComponent;
  }

  hideModal() {
    this.$modal.hide(this.modalName);
  }

  onComponentAdd(type: TComponentType) {
    if (this.componentIsUnique(type) && this.hasComponent(type)) return;
    this.hideModal();
    this.addComponent(type);
  }

  hasComponent(TComponentType) {
    return this.components.map((component) => component.type).includes(TComponentType);
  }

  get simpleComponents(): ISelector[] {
    return this.componentListGroup.simpleComponents;
  }

  get streamlabsComponents(): ISelector[] {
    return this.componentListGroup.streamlabsComponents;
  }
}
